import { CardsList } from '../CardsList';
import './MoreCalculators.scss';

export const MoreCalculators = () => {
  return (
    <section className='more-calculators mx-auto'>
      <h3 className='mb-3'>More Calculators</h3>
      <CardsList />
    </section>
  );
};
